import axios from "axios";

const api = process.env.REACT_APP_API_LOCATIONS || "";

const ConsultarSubLocation = async (specific = null, token) => {
  const apiUrl = `${api}/sublocations?specific=${specific}`;
  try {
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error en la consulta:", error);
    throw error;
  }
};

const consultarUbicaciones = async (token, lastEvaluatedKey = null) => {
  const apiUrl = `${api}/locations`;
  try {
    const params = { limit: 300 };
    if (lastEvaluatedKey) {
      params.startKey = lastEvaluatedKey;
    }
    const response = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
      params,
    });
    return response.data;
  } catch (error) {
    console.error("Error en la consulta:", error);
    throw error;
  }
};

const crearLocacion = async (data, token) => {
  const apiUrl = `${api}/locations`;
  try {
    const response = await axios.post(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al crear locación:", error.response?.data || error.message);
    throw error;
  }
};

const editarLocacion = async (data, idLocation, token) => {
  const apiUrl = `${api}/locations/${idLocation}`;
  try {
    const response = await axios.patch(apiUrl, data, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al editar locación:", error.response?.data || error.message);
    throw error;
  }
};

const deshabilitarLocacion = async (idLocation, token) => {
  const apiUrl = `${api}/locations/${idLocation}`;
  const data = JSON.stringify({});
  try {
    const response = await axios.delete(apiUrl, {
      data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al deshabilitar locación:", error.response?.data || error.message);
    throw error;
  }
};

const habilitarLocacion = async (idLocation, token) => {
  const apiUrl = `${api}/locations/${idLocation}`;
  const data = JSON.stringify({});
  try {
    const response = await axios.put(apiUrl, {
      data,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error al habilitar locación:", error.response?.data || error.message);
    throw error;
  }
};

const locationService = {
  ConsultarSubLocation,
  consultarUbicaciones,
  crearLocacion,
  deshabilitarLocacion,
  habilitarLocacion,
  editarLocacion,
};

export default locationService;
